export const FirebaseConfig = {
	"projectId": "delzo-401608",
	"appId": "1:904284837617:web:707acbf4b42d1cb8c77b50",
	"databaseURL": "https://delzo-401608-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "delzo-401608.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDvqi2CNTMkFr5HwCdE2IdtqjY-7Tr-MB4",
	"authDomain": "delzo-401608.firebaseapp.com",
	"messagingSenderId": "904284837617",
	"measurementId": "G-L9ZVX9Q3CE"
};